const REFERRER_MAP = [
  { match: "instagram", source: "instagram" },
  { match: "tiktok", source: "tiktok" },
  { match: "facebook", source: "facebook" },
  { match: "fb.com", source: "facebook" },
  { match: "twitter", source: "x" },
  { match: "t.co", source: "x" },
  { match: "x.com", source: "x" },
  { match: "google", source: "google" },
  { match: "youtube", source: "youtube" },
  { match: "reddit", source: "reddit" },
  { match: "snapchat", source: "snapchat" },
];

export function detectTrafficSource() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source");
    if (utmSource) return utmSource.toLowerCase();

    const referrer = document.referrer;
    if (!referrer) return "direct";
    const hostname = new URL(referrer).hostname.toLowerCase();
    const found = REFERRER_MAP.find((r) => hostname.includes(r.match));
    return found ? found.source : "other";
  } catch {
    return "direct";
  }
}
